import React from 'react';
import styled from 'styled-components';
import SignatureOrder from './SignatureOrder';

const ControllerContainer = styled.div`
  min-height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.8);
  position: absolute;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px 24px 16px;
`;

const SignatureOrderModal = ({ closeModal }) => {
  return (
    <ControllerContainer>
      <SignatureOrder closeModal={closeModal} />
    </ControllerContainer>
  );
};

export default SignatureOrderModal;
